import { useTheme } from '@automata/mui-theme';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { type ReactNode, forwardRef } from 'react';

import { toolbarStyles } from '../../styles';

type SelectionPanelProps = {
  title: string;
  children: ReactNode;
};

export const SelectionPanelBase = forwardRef<
  HTMLDivElement,
  SelectionPanelProps
>(function SelectionPanel({ title, children }, ref) {
  const theme = useTheme();

  return (
    <Stack ref={ref} sx={toolbarStyles} minWidth="12em">
      <Typography p={1} variant="subtitle1" bgcolor={theme.palette.grey[200]}>
        {title}
      </Typography>

      <Stack p={1} gap={1} maxHeight="80vh" overflow="auto">
        {children}
      </Stack>
    </Stack>
  );
});

export interface HandleClickOutsideProps {
  handleClickOutside: () => void;
}
